import { useEffect, useState } from 'react';

export default function useHandleErrorLogic() {
  const [err, setErr] = useState<any>(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!err) return;
      setErr(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, [err]);

  return [err, setErr];
}
